import { Column, NoDataWrapper } from './styled';
export function NoData() {
  return (
    <NoDataWrapper>
      <Column
        justifyContent="center"
        alignContent="center"
        alignItem="center"
        displayFlex
      >
        <p>No data</p>
      </Column>
    </NoDataWrapper>
  );
}
